// src/data/serumsImg/boostImages.js

export const boostSetImages = {
  imgBanner: require("../../img/jetCare-serums/Opening_pages_Boost.png"),
  imgModal: require("../../img/jetCare-serums/Boost_Set.png"),
  productsImages: {
    "hydrate": {
      image: require("../../img/jetCare-serums/Boost_G.18.png"),
      imageBig: require("../../img/jetCare-serums/Hydrate.png")
    },
    "regenerate": {
      image: require("../../img/jetCare-serums/Boost_G.20.png"),
      imageBig: require("../../img/jetCare-serums/Regenerate.png")
    },
    "glow": {
      image: require("../../img/jetCare-serums/Boost_G.17.png"),
      imageBig: require("../../img/jetCare-serums/Glow.png")
    },
    "tight": {
      image: require("../../img/jetCare-serums/boost_T_New.26.png"),
      imageBig: require("../../img/jetCare-serums/Tight.png")
    },
    "boost-set": {
      image: require("../../img/jetCare-serums/Boost_G.21.png"),
      imageBig: require("../../img/jetCare-serums/Set.png")
    }
  }
};
